// extracted by mini-css-extract-plugin
export var animationContainer = "_f7-0";
export var asteriskIcon = "_f7-8";
export var conversationLeftSection = "_f7-4";
export var conversationListItem = "_f7-3";
export var conversationMiddleSection = "_f7-5";
export var conversationRightSection = "_f7-6";
export var detailsContent = "_f7-1";
export var listContainer = "_f7-7";
export var modalContent = "_f7-2";